export default "__VITE_ASSET__DoUr2K1d__"